import React from "react";
import { View, Text } from "react-native";

const StreamPlayer = ({ platform, streamUrl, height, width }) => {
  const getCurrentHostname = () => {
    if (typeof window !== "undefined") {
      return window.location.hostname;
    }
    return "testing.d246i6gj3tz2g1.amplifyapp.com";
  };

  const getEmbedUrl = (url: string, platform: string) => {
    if (platform === "twitch" && url.includes("/videos/")) {
      const videoId = url.split("/videos/")[1];
      return `https://player.twitch.tv/?video=${videoId}&parent=${getCurrentHostname()}&autoplay=true&muted=true`;
    }
    if (platform === "youtube") {
      let videoId = "";
      if (url.includes("youtube.com/watch?v=")) {
        videoId = url.split("v=")[1].split("&")[0];
      } else if (url.includes("youtube/")) {
        videoId = url.split("youtube/")[1].split("?")[0];
      } else if (url.includes("youtube.com/embed/")) {
        return url;
      }
      if (videoId) {
        return `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1&controls=1`;
      }
    }
    return url;
  };

  const embedUrl = getEmbedUrl(streamUrl, platform);

  return streamUrl ? (
    <View style={{ position: "relative" }}>
      <iframe
        src={embedUrl}
        height={height}
        width={width}
        style={{ border: "none", borderRadius: "8px", overflow: "hidden" }}
        allowFullScreen
        allow="autoplay; encrypted-media"
      />
    </View>
  ) : (
    <View
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width,
        height,
        backgroundColor: "#333",
        borderRadius: 8,
      }}
    >
      <Text style={{ color: "#fff", fontSize: 16, fontWeight: "bold" }}>
        Stream will be live soon
      </Text>
    </View>
  );
};

export default StreamPlayer;
